module.exports = __webpack_public_path__ + "static/media/Abhishek Verma.c9101d4d.png";